import React, { Fragment, useState, useEffect, useMemo } from 'react'
import { toast } from 'react-toastify';
import { useHistory } from "react-router-dom";

//material ui

import {
  Stack,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Grid,
  TextField,
  Card,
  Typography,
  CircularProgress,
  Tab,
  Tabs,
  Box,
  Checkbox,
  FormControlLabel,
  Button,
  Container,
  Divider,
  Paper,
  Fade,
  Collapse,
  LinearProgress,
  Avatar
} from '@mui/material';
import Alert from '@material-ui/lab/Alert';
//icons
import { FiArrowLeftCircle, FiUser, FiMapPin, FiCreditCard, FiSearch, FiTruck, FiShoppingBag, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
//redux
import { useDispatch, useSelector } from "react-redux";
//actions
import Actions from "../../constants/Actions";
import buscaCep from "../../actions/buscaCep";
import criarCliente from '../../actions/cadastro/criar-cliente'
//services
import { getCepUser, getDataUsuario, getIsMaquininhaUser } from '../../services/auth'
//utils
import { getValorTotal, soNumeros, maskCPF, maskDate, validarCPF, phoneMask, getValorSubTotal } from '../../utils/functions';
//components
import Stepper from "../../components/Stepper";
import CartResumo from '../../components/CartResumo';
// actions novo
import criarPedido from '../../actions/pedidos/criar-pedido';
import buscarClientePorCpfLinx from '../../actions/cadastro/buscar-cliente-por-cpf-linx';
import consultarClientePorCpf from '../../actions/cadastro/consultar-cliente-cpf';
import editarCliente from '../../actions/cadastro/editar-cliente';
import CheckoutShipping from '../../sections/checkout/CheckoutShipping';
import v2_actionCliente from '../../actions/v2/clientes/v2_actionCliente';

const moment = require('moment');

// ====== Design System Tokens ======
const BRAND = '#1a1a2e';
const BRAND_HOVER = '#16213e';
const BRAND_LIGHT = '#e8eaf0';
const ACCENT = '#0ea5e9';

const sectionHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mb: 1.5,
  mt: 0.5,
};

const sectionIconSx = {
  width: 28,
  height: 28,
  bgcolor: BRAND_LIGHT,
  color: BRAND,
  fontSize: 14,
};

const sectionTitleSx = {
  fontWeight: 700,
  fontSize: '0.9rem',
};

const cardSx = {
  p: { xs: 1.75, md: 2 },
  borderRadius: 2,
  border: '1px solid',
  borderColor: 'grey.200',
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
};

const inputSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 1.5,
    '&.Mui-focused fieldset': { borderColor: BRAND },
  },
  '& .MuiInputLabel-root.Mui-focused': { color: BRAND },
};

const ItemPaymentType = ({ title, onClick, background, disabled }) => {
  const isSelected = !!background;
  return (
    <Paper
      elevation={0}
      onClick={disabled ? undefined : onClick}
      sx={{
        borderRadius: 1.5,
        px: 1.5,
        py: 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        border: '2px solid',
        borderColor: isSelected ? BRAND : 'grey.300',
        bgcolor: isSelected ? BRAND_LIGHT : '#fff',
        transition: 'all 0.15s ease',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 88,
        position: 'relative',
        '&:hover': {
          borderColor: BRAND,
          bgcolor: BRAND_LIGHT,
        },
      }}
    >
      {isSelected && (
        <Box sx={{ position: 'absolute', top: 4, right: 4, color: BRAND, fontSize: 14, display: 'flex' }}>
          <FiCheckCircle />
        </Box>
      )}
      <Typography
        sx={{
          fontWeight: isSelected ? 700 : 500,
          fontSize: '0.8rem',
          color: isSelected ? BRAND : 'text.secondary',
          textAlign: 'center',
        }}
      >
        {title}
      </Typography>
    </Paper>
  );
};

const ResumoPage = ({ proximoPasso }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [cpf, setCpf] = useState('');
  const [nomeCompleto, setNomeCompleto] = useState('');
  const [nome, setNome] = useState('');
  const [sobrenome, setSobrenome] = useState('');
  const [telefone, setTelefone] = useState('');
  const [email, setEmail] = useState('');
  const [cep, setCep] = useState('');
  const [dataNascimento, setDataNascimento] = useState('');
  const [rua, setRua] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');
  const [tipoPagamento, setTipoPagamento] = useState('');
  const [transportadora, setTransportadora] = useState('');
  const [cpfBuscado, setCpfBuscado] = React.useState('Inicial');
  const [parcelaSelecionada, setParcelaSelecionada] = useState('1');
  const valorFrete = useSelector(state => state.valorFrete);
  const [valorAjuste, setValorAjuste] = React.useState(0);
  const valorDesconto = useSelector(state => state.valorDesconto);
  const cartItems = useSelector(state => state.cartItems);
  const [tipoEntrega, setTipoEntrega] = useState("Retirada")
  const shippingId = useSelector(state => state.shippingId);
  const paymentId = useSelector(state => state.paymentId);
  const tipoEntrega2 = useSelector(state => state.tipoEntrega);
  const [value, setValue] = useState(0);
  const [clienteId, setClienteId] = useState('');


  // endereço de cobrança
  const [addressIsCob, setAddressIsCob] = useState(false);
  const [cepCob, setCepCob] = useState('');
  const [ruaCob, setRuaCob] = useState('');
  const [numeroCob, setNumeroCob] = useState('');
  const [complementoCob, setComplementoCob] = useState('');
  const [bairroCob, setBairroCob] = useState('');
  const [cidadeCob, setCidadeCob] = useState('');
  const [estadoCob, setEstadoCob] = useState('');


  const [loadingCriarPedido, setLoadingCriarPedido] = useState(false);
  const valorTotalGeral = getValorTotal(cartItems, valorFrete, valorDesconto, valorAjuste);

  // Estado para controlar mensagem de campos faltando
  const [camposFaltando, setCamposFaltando] = useState([]);
  const [mostrarMensagemCampos, setMostrarMensagemCampos] = useState(false);
  const [errosCampo, setErrosCampo] = useState({});
  const [tentouSubmeter, setTentouSubmeter] = useState(false);

  // Carrinho vazio: avisar e redirecionar para o início
  useEffect(() => {
    if (!cartItems || cartItems.length === 0) {
      toast.warning('Seu carrinho está vazio. Você será redirecionado para a página inicial.', {
        position: 'top-right',
        autoClose: 3000,
      });
      history.push('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ====== Validação consolidada (pure compute via useMemo) ======
  const validacao = useMemo(() => {
    const erros = {};
    const fieldLabels = {
      cpf: 'CPF',
      nome: 'Nome',
      sobrenome: 'Sobrenome',
      telefone: 'Telefone',
      email: 'Email',
      cep: 'CEP',
      rua: 'Logradouro',
      numero: 'Número',
      bairro: 'Bairro',
      cidade: 'Cidade',
      estado: 'Estado',
      tipoPagamento: 'Forma de Pagamento',
      shippingId: 'Forma de Entrega',
};

    const isEmpty = (v) => v === undefined || v === null || String(v).trim() === '';

    if (isEmpty(cpf)) erros.cpf = 'CPF é obrigatório';
    else if (!validarCPF(cpf)) erros.cpf = 'CPF inválido';

    if (isEmpty(nome)) erros.nome = 'Nome é obrigatório';
    if (isEmpty(sobrenome)) erros.sobrenome = 'Sobrenome é obrigatório';
    if (isEmpty(telefone)) erros.telefone = 'Telefone é obrigatório';

    if (isEmpty(email)) erros.email = 'Email é obrigatório';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) erros.email = 'Email inválido';

    if (isEmpty(cep)) erros.cep = 'CEP é obrigatório';
    if (isEmpty(rua)) erros.rua = 'Logradouro é obrigatório';
    if (isEmpty(numero)) erros.numero = 'Número é obrigatório';
    if (isEmpty(bairro)) erros.bairro = 'Bairro é obrigatório';
    if (isEmpty(cidade)) erros.cidade = 'Cidade é obrigatória';
    if (isEmpty(estado)) erros.estado = 'Estado é obrigatório';

    if (isEmpty(tipoPagamento)) erros.tipoPagamento = 'Selecione uma forma de pagamento';

    if (!shippingId) erros.shippingId = 'Selecione uma forma de entrega';

    const camposFaltandoLista = Object.keys(erros).map((k) => fieldLabels[k] || k);

    return {
      valido: camposFaltandoLista.length === 0,
      errosPorCampo: erros,
      camposFaltando: camposFaltandoLista,
    };
  }, [
    cpf, nome, sobrenome, telefone, email,
    cep, rua, numero, bairro, cidade, estado,
    tipoPagamento, shippingId,
  ]);

  // Sincronizar estado visual com a validação calculada
  useEffect(() => {
    if (cpfBuscado === 'Buscado' || tentouSubmeter) {
      setErrosCampo(validacao.errosPorCampo);
      setCamposFaltando(validacao.camposFaltando);
      setMostrarMensagemCampos(tentouSubmeter && validacao.camposFaltando.length > 0);
    }
  }, [validacao, cpfBuscado, tentouSubmeter]);

  const voltarPdv = () => {
    history.push('frete')
  }


  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 1) {
      handleLinkPagamento();
    } else {
      setTipoPagamento("");
    }
  };

  const handleChangeAddressIsCob = (event) => {
    setAddressIsCob(event.target.checked);
    setBairroCob(bairro);
    setRuaCob(rua);
    setEstadoCob(estado);
    setCepCob(cep);
    setNumeroCob(numero);
    setCidadeCob(cidade);
    setComplementoCob(complemento);

  };

  const notifyError = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const notifyWarning = (message) => {
    toast.warning(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const limparCampos = () => {
    setNomeCompleto("");
    setTelefone("");
    setBairro("");
    setRua("");
    setEstado("");
    setCep("");
    setNumero("");
    setCidade("");
    setComplemento("");
    setEmail("");
  }

  const limparCamposCob = () => {
    setBairroCob("");
    setRuaCob("");
    setEstadoCob("");
    setCepCob("");
    setNumeroCob("");
    setCidadeCob("");
    setComplementoCob("");
  }

  const handleBuscaCep = async (zipCode) => {
    try {
      const address = await buscaCep(zipCode)
      if (address.erro) {
        alert('CEP não encontrado!')
      } else {
        setCidade(address.localidade);
        setEstado(address.uf);
        return address;
      }
    } catch (address) {
      alert('CEP não encontrado!');
    }
  }



  const buscarCpfMongo = () => {
    limparCampos();

    if (cpf.length === 11) {
      setCpfBuscado('Buscando');

      if (validarCPF(cpf) === true) {
        consultarClientePorCpf(soNumeros(cpf)).then(res => {
          if (res.data.isCliente) {
            setClienteId(res.data.data._id);
            setCpfBuscado('Buscado');
            setNome(res.data.data.first_name);
            setSobrenome(res.data.data.last_name);
            setTelefone(res.data.data.phone);
            setDataNascimento(res.data.data.data_nascimento);
            setBairro(res.data.data.endereco_entrega[0].bairro);
            setRua(res.data.data.endereco_entrega[0].logradouro);
            setEstado(res.data.data.endereco_entrega[0].uf);
            setCep(res.data.data.endereco_entrega[0].cep);
            setNumero(res.data.data.endereco_entrega[0].numero);
            setCidade(res.data.data.endereco_entrega[0].localidade);
            setComplemento(res.data.data.endereco_entrega[0].complemento);
            setEmail(res.data.data.email);
          } else {
            notifyWarning("Esse CPF não possui cadastro no Venda Fácil, buscando em USE....");
            buscarCpfLinx();
            setClienteId('');
          }
        }).catch(() => {
          setCpfBuscado('Buscado');
          notifyError("Não foi possível estabelecer conexão com Venda Fácil");
        });
      } else {
        setCpfBuscado('Inicial');
        notifyError("CPF Digitado é inválido");
      }



    }
  }



  const buscarCpfLinx = async () => {
    limparCampos();
    if (cpf.length === 11) {
      setCpfBuscado('Buscando');
      setTimeout(() => {
        if (!cpfBuscado === 'Buscado')
          setCpfBuscado('Buscado');
      }, 10000);

      if (validarCPF(cpf) === true) {

        try {
          const response = await v2_actionCliente(soNumeros(cpf));
          const {data} = response.data
          if(response.status === 200) {
              setCpfBuscado('Buscado');
              setNomeCompleto(data.nome + " " + data.sobrenome);
              setNome(data.nome);
              setSobrenome(data.sobrenome);
              setTelefone(data.telefone1);
              setDataNascimento(moment((new Date(data.nascimento	)).toLocaleString('en-US', { timeZone: 'Europe/Berlin' })).format("DD/MM/YYYY"));
              setBairro(data.bairro);
              setRua(data.endereco);
              setEstado(data.estado);
              setCep(data.cep);
              setNumero(data.numero);
              setCidade(data.cidade);
              setComplemento(data.complemento);
              setEmail(data.email);
              dispatch({ type: Actions.SHIPPING_ID, shippingId: null });
          }
        } catch (err) {
          setCpfBuscado('Buscado');
          notifyError("Não foi possível estabelecer conexão com Linx");
        }

      } else {
        setCpfBuscado('Inicial');
        notifyError("CPF Digitado é inválido");
      }



    }
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const onStartPedido = async (id) => {

    try {
      let statusId = "60774fa684e6861cb41a472f";
      let shippingPrice = valorFrete;
      let items = cartItems;
      let parcelas = parcelaSelecionada;
      let desconto = valorDesconto;
      let responseZoop = null;
      let dadosOrigemPedido = {
        cpf: getDataUsuario().cpf,
        filial: getDataUsuario().filial,
        nome: getDataUsuario().nome,
        sobrenome: getDataUsuario().sobrenome
      }

      let personalData = {
        full_name: nome + " " + sobrenome,
        nome: nome,
        sobrenome: sobrenome,
        mobile: telefone,
        cpf: soNumeros(cpf),
        email: email ? email : ""
      }

      let shippingAddress = {
        full_name: nomeCompleto,
        address1: rua,
        address2: bairro,
        city: cidade,
        country: "Brazil",
        postal_code: cep,
        state: estado,
        phone: soNumeros(telefone),
        number: soNumeros(numero),
        company: "",
        tax_number: "",
        coordinates: {
          latitude: "",
          longitude: ""
        },
        details: complemento

      }

      let billingAddress = {

        full_name: nomeCompleto,
        address1: rua,
        address2: bairro,
        city: cidade,
        country: "Brazil",
        postal_code: cep,
        state: estado,
        phone: telefone,
        number: numero,
        company: "",
        tax_number: "",
        coordinates: {
          latitude: "",
          longitude: ""
        },
        details: complemento,
      }

      let dataToSend = { customerId: id, desconto, billingAddress, shippingAddress, personalData, items, shippingPrice, statusId, tipoEntrega:tipoEntrega2, shippingId, paymentId, parcelas, responseZoop, dadosOrigemPedido }

      const responsePedido = await criarPedido(dataToSend)
      setLoadingCriarPedido(false)


      if (responsePedido) {
        setLoadingCriarPedido(false)
        dispatch({ type: Actions.ORDER_NUMBER, orderNumber: responsePedido.data.number });
        dispatch({ type: Actions.MEU_CARRINHO, cartItems: [] });
        history.push(`/pdv/conclusao?order=${responsePedido.data.number}`);
      }

    } catch (error) {
      setLoadingCriarPedido(false);
      alert('Erro ao Criar Pedido, tente novamente. Caso o erro persista, entre em contato com o suporte');
    }

  }

  const onCriarCliente = async () => {
    let data = {
      email,
      phone: telefone,
      nome,
      sobrenome,
      password: null,
      data_nascimento: dataNascimento,
      cpf: cpf,
      endereco_entrega: [{
        logradouro: rua,
        numero: numero,
        bairro: bairro,
        localidade: cidade,
        cep: cep,
        uf: estado,
        complemento: complemento
      }],
      endereco_cobranca: [{
        logradouro: ruaCob,
        numero: numeroCob,
        bairro: bairroCob,
        localidade: cidadeCob,
        cep: cepCob,
        uf: estadoCob,
        complemento: complementoCob
      }]
    }

    try {
      const res = await criarCliente(data);
      await onStartPedido(res.data.data._id);
      setClienteId(res.data.data._id);
    } catch (error) {
      notifyError("Erro ao cadastrar no Venda Fácil");
    }

  }

  const onEditarCliente = async () => {
    let data = {
      email,
      phone: telefone,
      nome,
      sobrenome,
      password: null,
      data_nascimento: dataNascimento,
      cpf: cpf,
      endereco_entrega: [{
        logradouro: rua,
        numero: numero,
        bairro: bairro,
        localidade: cidade,
        cep: cep,
        uf: estado,
        complemento: complemento
      }],
      endereco_cobranca: [{
        logradouro: ruaCob,
        numero: numeroCob,
        bairro: bairroCob,
        localidade: cidadeCob,
        cep: cepCob,
        uf: estadoCob,
        complemento: complementoCob
      }]
    }

    try {
      const res = await editarCliente(clienteId, data);
    } catch (error) {
      notifyError("Erro ao cadastrar no Venda Fácil");
    }

  }

  const fazerPedido = async () => {
    setTentouSubmeter(true);

    if (!validacao.valido) {
      notifyError('Preencha todos os campos obrigatórios antes de continuar');
      return;
    }

    setLoadingCriarPedido(true)
    if (clienteId) {
      try {
        await onEditarCliente();
        await onStartPedido(clienteId);
      } catch (error) {
        setLoadingCriarPedido(false)
        alert('Erro ao cadastrar cliente');
      }
    } else {
      try {
        await onCriarCliente();
        setLoadingCriarPedido(false)
      } catch (error) {
        setLoadingCriarPedido(false)
        alert('Erro ao cadastrar cliente');
      }
    }
  }




  const handleChangeParcelas = (event) => {
    setParcelaSelecionada(event.target.value);
  };


  const handlePixCheckout = () => {
    setTipoPagamento('Pix Checkout');
    setParcelaSelecionada("1");
    dispatch({ type: Actions.PAYMENT_ID, paymentId: "62c753914e8a07e77586dc82" });
  }

  const handleLinkPagamento = () => {
    dispatch({ type: Actions.PAYMENT_ID, paymentId: "6168e6afbec438dc351a3067" });
    setTipoPagamento('Link Pagamento')
  }



  const handleEscolhePropria = () => {
    setTransportadora('Total');
    dispatch({ type: Actions.SHIPPING_ID, shippingId: "61560325eaf72f4fe7f5ee27" });
    dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })

    if (tipoEntrega === "Retirada") {
      if (getCepUser() >= 35500000 & getCepUser() <= 35505000) {
        dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
      } else {
        if (getValorSubTotal(cartItems) < 149) {
          dispatch({ type: Actions.valorFrete, valorFrete: 20.00 })
        } else {
          dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
        }
      }
    }


    if (tipoEntrega === 'Entrega') {
      if (cep >= 35500000 & cep <= 35505000) {
        if (getValorSubTotal(cartItems) < 199) {
          dispatch({ type: Actions.valorFrete, valorFrete: 14.00 })
        } else {
          dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
        }
      } else {
        if (getValorSubTotal(cartItems) < 199) {
          dispatch({ type: Actions.valorFrete, valorFrete: 20.00 })
        } else {
          dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
        }
      }
    }
  }

  // ====== RENDER ======
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>

      {/* ====== HEADER ====== */}
      <Box sx={{
        width: '100%',
        bgcolor: '#fff',
        py: 1,
        px: { xs: 2, md: 3 },
        borderBottom: '1px solid #e5e5e5',
      }}>
        <Stack justifyContent="space-between" alignItems="center" direction="row">
          <IconButton onClick={voltarPdv} sx={{ color: '#333' }} size="small">
            <FiArrowLeftCircle size={24} />
          </IconButton>
          <Stepper valorStep={2} />
        </Stack>
      </Box>

      {/* Loading bar */}
      <Collapse in={cpfBuscado === 'Buscando'}>
        <LinearProgress sx={{ height: 3, '& .MuiLinearProgress-bar': { bgcolor: ACCENT }, bgcolor: '#e0e0e0' }} />
      </Collapse>

      {/* ====== CONTENT ====== */}
      <Box sx={{ px: { xs: 2, md: 3 }, py: 2 }}>
        <Stack direction={{ xs: 'column', lg: 'row' }} spacing={2} alignItems="flex-start">

          {/* ====== LEFT: Customer Data ====== */}
          <Box sx={{ width: { xs: '100%', lg: '44%' } }}>
            <Card sx={cardSx}>

              {/* CPF Search */}
              <Box sx={sectionHeaderSx}>
                <Avatar sx={sectionIconSx}><FiSearch size={14} /></Avatar>
                <Typography variant="subtitle1" sx={sectionTitleSx}>
                  Identificação do Cliente
                </Typography>
              </Box>

              <Stack direction="row" spacing={1.5} alignItems="center">
                <TextField
                  fullWidth variant="outlined" label="CPF do Cliente" size="small"
                  placeholder="000.000.000-00"
                  value={maskCPF(cpf)}
                  onChange={e => setCpf(soNumeros(e.target.value))}
                  error={tentouSubmeter && !!errosCampo.cpf}
                  helperText={tentouSubmeter ? errosCampo.cpf : ''}
                  sx={inputSx}
                />
                <Button
                  onClick={buscarCpfMongo}
                  disabled={cpfBuscado === 'Buscando'}
                  variant="contained"
                  size="large"
                  sx={{
                    minWidth: 130, height: 40, borderRadius: 1.5,
                    textTransform: 'none', fontWeight: 600,
                    bgcolor: BRAND, '&:hover': { bgcolor: BRAND_HOVER },
                  }}
                >
                  {cpfBuscado === 'Buscando' ? <CircularProgress size={22} sx={{ color: '#fff' }} /> : 'Pesquisar'}
                </Button>
              </Stack>

              {/* Customer form after CPF search */}
              <Collapse in={cpfBuscado === 'Buscado'}>
                <Fade in={cpfBuscado === 'Buscado'} timeout={500}>
                  <Box>

                    {/* Personal Info */}
                    <Divider sx={{ my: 2 }} />
                    <Box sx={sectionHeaderSx}>
                      <Avatar sx={sectionIconSx}><FiUser size={14} /></Avatar>
                      <Typography variant="subtitle1" sx={sectionTitleSx}>
                        Informações Pessoais
                      </Typography>
                    </Box>

                    <Grid container spacing={1.5}>
                      <Grid item md={6} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Nome" value={nome} size="small" onChange={e => setNome(e.target.value)}
                          error={tentouSubmeter && !!errosCampo.nome}
                          helperText={tentouSubmeter ? errosCampo.nome : ''}
                          sx={inputSx} />
                      </Grid>
                      <Grid item md={6} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Sobrenome" value={sobrenome} size="small" onChange={e => setSobrenome(e.target.value)}
                          error={tentouSubmeter && !!errosCampo.sobrenome}
                          helperText={tentouSubmeter ? errosCampo.sobrenome : ''}
                          sx={inputSx} />
                      </Grid>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Data Nasc." value={dataNascimento} size="small" onChange={e => setDataNascimento(maskDate(e.target.value))} sx={inputSx} />
                      </Grid>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Telefone" value={phoneMask(telefone)} size="small" onChange={e => setTelefone(e.target.value)}
                          error={tentouSubmeter && !!errosCampo.telefone}
                          helperText={tentouSubmeter ? errosCampo.telefone : ''}
                          sx={inputSx} />
                      </Grid>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Email" value={email} size="small" onChange={e => setEmail(e.target.value)}
                          error={tentouSubmeter && !!errosCampo.email}
                          helperText={tentouSubmeter ? errosCampo.email : ''}
                          sx={inputSx} />
                      </Grid>
                    </Grid>

                    {/* Shipping Address */}
                    <Divider sx={{ my: 2 }} />
                    <Box sx={sectionHeaderSx}>
                      <Avatar sx={sectionIconSx}><FiMapPin size={14} /></Avatar>
                      <Typography variant="subtitle1" sx={sectionTitleSx}>
                        Endereço de Entrega
                      </Typography>
                    </Box>

                    <Grid container spacing={1.5}>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField
                          fullWidth variant="outlined" label="CEP" value={cep} size="small"
                          onChange={e => setCep(e.target.value)}
                          onBlur={() => {
                            if (cep.length === 8) {
                              buscaCep(cep).then(res => {
                                setBairro(res.bairro); setRua(res.logradouro);
                                setEstado(res.uf); setCidade(res.localidade);
                                setComplemento(""); setNumero("");
                              }).catch(() => {})
                            }
                          }}
                          error={tentouSubmeter && !!errosCampo.cep}
                          helperText={tentouSubmeter ? errosCampo.cep : ''}
                          sx={inputSx}
                        />
                      </Grid>
                      <Grid item md={8} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Logradouro" value={rua} size="small" onChange={e => setRua(e.target.value)}
                          error={tentouSubmeter && !!errosCampo.rua}
                          helperText={tentouSubmeter ? errosCampo.rua : ''}
                          sx={inputSx} />
                      </Grid>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Bairro" value={bairro} size="small" onChange={e => setBairro(e.target.value)}
                          error={tentouSubmeter && !!errosCampo.bairro}
                          helperText={tentouSubmeter ? errosCampo.bairro : ''}
                          sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={4} xs={4}>
                        <TextField fullWidth variant="outlined" label="Número" value={numero} size="small" onChange={e => setNumero(e.target.value)}
                          error={tentouSubmeter && !!errosCampo.numero}
                          helperText={tentouSubmeter ? errosCampo.numero : ''}
                          sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={8} xs={8}>
                        <TextField fullWidth variant="outlined" label="Complemento" value={complemento} size="small" onChange={e => setComplemento(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={8} xs={8}>
                        <TextField fullWidth variant="outlined" label="Cidade" value={cidade} size="small" onChange={e => setCidade(e.target.value)}
                          error={tentouSubmeter && !!errosCampo.cidade}
                          helperText={tentouSubmeter ? errosCampo.cidade : ''}
                          sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={4} xs={4}>
                        <TextField fullWidth variant="outlined" label="Estado" value={estado} size="small" onChange={e => setEstado(e.target.value)}
                          error={tentouSubmeter && !!errosCampo.estado}
                          helperText={tentouSubmeter ? errosCampo.estado : ''}
                          sx={inputSx} />
                      </Grid>
                    </Grid>

                    {/* Same address checkbox */}
                    <FormControlLabel
                      sx={{ mt: 2, '& .MuiTypography-root': { fontSize: '0.875rem', color: 'text.secondary' } }}
                      control={
                        <Checkbox checked={addressIsCob} onChange={handleChangeAddressIsCob} name="checkedB"
                          sx={{ '&.Mui-checked': { color: BRAND } }} />
                      }
                      label="Endereço de entrega é o mesmo de cobrança"
                    />

                    {/* Billing Address */}
                    <Divider sx={{ my: 2 }} />
                    <Box sx={sectionHeaderSx}>
                      <Avatar sx={sectionIconSx}><FiMapPin size={14} /></Avatar>
                      <Typography variant="subtitle1" sx={sectionTitleSx}>
                        Endereço de Cobrança
                      </Typography>
                    </Box>

                    <Grid container spacing={1.5}>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField
                          fullWidth variant="outlined" label="CEP" value={cepCob} size="small"
                          onChange={e => setCepCob(e.target.value)}
                          onBlur={() => {
                            if (cepCob.length === 8) {
                              buscaCep(cepCob).then(res => {
                                setBairroCob(res.bairro); setRuaCob(res.logradouro);
                                setEstadoCob(res.uf); setCidadeCob(res.localidade);
                                setComplementoCob(""); setNumeroCob("");
                              }).catch(() => {})
                            }
                          }}
                          sx={inputSx}
                        />
                      </Grid>
                      <Grid item md={8} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Logradouro" value={ruaCob} size="small" onChange={e => setRuaCob(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={4} sm={12} xs={12}>
                        <TextField fullWidth variant="outlined" label="Bairro" value={bairroCob} size="small" onChange={e => setBairroCob(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={4} xs={4}>
                        <TextField fullWidth variant="outlined" label="Número" value={numeroCob} size="small" onChange={e => setNumeroCob(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={8} xs={8}>
                        <TextField fullWidth variant="outlined" label="Complemento" value={complementoCob} size="small" onChange={e => setComplementoCob(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={8} xs={8}>
                        <TextField fullWidth variant="outlined" label="Cidade" value={cidadeCob} size="small" onChange={e => setCidadeCob(e.target.value)} sx={inputSx} />
                      </Grid>
                      <Grid item md={2} sm={4} xs={4}>
                        <TextField fullWidth variant="outlined" label="Estado" value={estadoCob} size="small" onChange={e => setEstadoCob(e.target.value)} sx={inputSx} />
                      </Grid>
                    </Grid>

                  </Box>
                </Fade>
              </Collapse>

              {/* Missing fields warning */}
              <Collapse in={mostrarMensagemCampos}>
                <Box sx={{
                  mt: 3, p: 2, borderRadius: 1.5,
                  bgcolor: '#fef3c7', border: '1px solid #fcd34d',
                  display: 'flex', alignItems: 'flex-start', gap: 1.5,
                }}>
                  <FiAlertCircle size={20} style={{ color: '#d97706', marginTop: 2, flexShrink: 0 }} />
                  <Box>
                    <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', color: '#92400e', mb: 0.5 }}>
                      Campos obrigatórios não preenchidos
                    </Typography>
                    <Typography sx={{ fontSize: '0.8rem', color: '#a16207' }}>
                      {camposFaltando.join(' · ')}
                    </Typography>
                  </Box>
                </Box>
              </Collapse>

            </Card>
          </Box>

          {/* ====== MIDDLE: Shipping + Payment ====== */}
          <Box sx={{ width: { xs: '100%', lg: '36%' } }}>
            <Stack spacing={2}>

              {/* Shipping */}
              <Collapse in={cpfBuscado === 'Buscado'}>
                <Card sx={cardSx}>
                  <Box sx={sectionHeaderSx}>
                    <Avatar sx={sectionIconSx}><FiTruck size={14} /></Avatar>
                    <Typography variant="subtitle1" sx={sectionTitleSx}>
                      Forma de Entrega
                    </Typography>
                  </Box>
                  <CheckoutShipping />
                </Card>
              </Collapse>

              {/* Payment */}
              {shippingId && cpf !== "" && cep !== "" && rua !== "" && numero !== "" && telefone && nome !== "" && sobrenome !== "" && (
                <Fade in timeout={400}>
                  <Card sx={cardSx}>
                    <Box sx={sectionHeaderSx}>
                      <Avatar sx={sectionIconSx}><FiCreditCard size={14} /></Avatar>
                      <Typography variant="subtitle1" sx={sectionTitleSx}>
                        Forma de Pagamento
                      </Typography>
                    </Box>

                    <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="payment tabs"
                      sx={{
                        mb: 2.5,
                        '& .MuiTabs-indicator': { bgcolor: BRAND, height: 2.5 },
                        '& .MuiTab-root': {
                          textTransform: 'none', fontWeight: 600, fontSize: '0.9rem',
                          color: 'text.secondary',
                          '&.Mui-selected': { color: BRAND },
                        },
                      }}
                    >
                      <Tab label="Na Loja" {...a11yProps(0)} />
                      <Tab label="Online" {...a11yProps(1)} />
                    </Tabs>

                    <TabPanel value={value} index={0}>
                      <Stack spacing={2}>
                        {getIsMaquininhaUser() === "false" && (
                          <Box sx={{
                            p: 2, borderRadius: 1.5, bgcolor: '#eff6ff',
                            border: '1px solid #bfdbfe', fontSize: '0.85rem', color: '#1e40af',
                          }}>
                            Sua loja não possui maquininha física. Utilize o Link de Pagamento para crédito ou a opção Pix abaixo.
                          </Box>
                        )}
                        <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
                          <ItemPaymentType
                            title="Pix"
                            onClick={handlePixCheckout}
                            background={tipoPagamento === 'Pix Checkout' ? '#b6ffca' : ''}
                          />
                        </Stack>
                      </Stack>
                    </TabPanel>

                    <TabPanel value={value} index={1}>
                      <ItemPaymentType
                        title="Link Pagamento"
                        onClick={handleLinkPagamento}
                        background={tipoPagamento === 'Link Pagamento' ? '#b6ffca' : ''}
                      />
                    </TabPanel>

                    {/* Link Pagamento info */}
                    <Collapse in={tipoPagamento === 'Link Pagamento'}>
                      <Box sx={{
                        mt: 2, p: 2, borderRadius: 1.5,
                        bgcolor: '#f0fdf4', border: '1px solid #bbf7d0',
                        fontSize: '0.85rem', color: '#166534',
                      }}>
                        Após a confirmação, será gerado um link de pagamento Katuxa Pay para compartilhar com o cliente.
                      </Box>
                    </Collapse>

                    {/* Submit Button */}
                    <Button
                      fullWidth variant="contained" onClick={fazerPedido}
                      disabled={loadingCriarPedido || !validacao.valido}
                      sx={{
                        mt: 3, py: 1.5, borderRadius: 1.5,
                        textTransform: 'none', fontWeight: 700, fontSize: '1rem',
                        bgcolor: '#16a34a',
                        '&:hover': { bgcolor: '#15803d' },
                        '&:disabled': { bgcolor: '#d1d5db' },
                      }}
                    >
                      {loadingCriarPedido ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Confirmar Pedido'}
                    </Button>
                    {!validacao.valido && !loadingCriarPedido && (
                      <Typography
                        sx={{
                          mt: 1, fontSize: '0.75rem', color: 'text.secondary', textAlign: 'center',
                        }}
                      >
                        Preencha os campos obrigatórios para continuar
                      </Typography>
                    )}

                  </Card>
                </Fade>
              )}

            </Stack>
          </Box>

          {/* ====== RIGHT: Cart Summary ====== */}
          <Box sx={{ width: { xs: '100%', lg: '20%' } }}>
            <Card sx={{
              ...cardSx,
              position: { lg: 'sticky' },
              top: { lg: 12 },
            }}>
              <Box sx={sectionHeaderSx}>
                <Avatar sx={sectionIconSx}><FiShoppingBag size={14} /></Avatar>
                <Typography variant="subtitle1" sx={sectionTitleSx}>
                  Resumo
                </Typography>
              </Box>
              <CartResumo />
            </Card>
          </Box>

        </Stack>
      </Box>
    </Box>
  )
}

export default ResumoPage;
